export default {
    FLOOR_EGG : 'FLOOR',
    NEST_EGG: 'NEST'
}